var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "section-spacing", attrs: { id: "catalog" } },
    [
      _c("div", { attrs: { id: "compare-modal" } }, [
        _c(
          "button",
          {
            staticClass: "close",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.closeCompare()
              }
            }
          },
          [_c("span", { staticClass: "fas fa-times" })]
        ),
        _vm._v(" "),
        _vm._m(0)
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isLoading,
              expression: "isLoading"
            }
          ],
          staticClass: "loader"
        },
        [_vm._m(1)]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "inner" }, [
        _c("div", { staticClass: "col-row auto-col-clear" }, [
          _c("div", { staticClass: "col l3 m12 s12" }, [
            _c("button", { attrs: { id: "toggleFilters" } }, [
              _vm._v("Filters")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "clearfix", attrs: { id: "selectedFilterTags" } },
              [
                _vm.model.sq
                  ? _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.selectMeta("sq", "")
                          }
                        }
                      },
                      [_vm._v("Search for: " + _vm._s(_vm.model.sq))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.model.attributed_to
                  ? _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.selectMeta("attributed_to", false)
                          }
                        }
                      },
                      [_vm._v("Attributed to: Yes")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.model.dimension
                  ? _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.selectMeta("dimension", "")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "Dimension: " +
                            _vm._s(_vm.list.dimensions[_vm.model.dimension])
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.model.favourites
                  ? _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.selectMeta("favourites", false)
                          }
                        }
                      },
                      [_vm._v("Favourites: Yes")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.model.foundry_mark
                  ? _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.selectMeta("foundry_mark", "")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "Foundry mark: " + _vm._s(_vm.model.foundry_mark)
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.model.item_in
                  ? _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.selectMeta("item_in", "")
                          }
                        }
                      },
                      [_vm._v("Item in: " + _vm._s(_vm.model.item_in))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.model.materials.length
                  ? _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.selectMeta("materials", "")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "Materials: " + _vm._s(_vm.model.materials.join(", "))
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.model.medium
                  ? _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.selectMeta("medium", "")
                          }
                        }
                      },
                      [_vm._v("Medium: " + _vm._s(_vm.model.medium))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.model.apply_year
                  ? _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.selectMeta("apply_year", false)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "Year: " +
                            _vm._s(
                              _vm.model.date.from + " - " + _vm.model.date.to
                            )
                        )
                      ]
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c("div", { attrs: { id: "filters" } }, [
              _vm.compare.length
                ? _c("div", { staticClass: "meta-box" }, [
                    _c("h4", { staticClass: "meta-title" }, [
                      _vm._v("Compare")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "toggle" },
                      _vm._l(_vm.maxCompare, function(idx) {
                        return _c("div", {
                          staticClass: "artwork-compare",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.compare[idx - 1]
                                ? _vm.getArtworkById(_vm.compare[idx - 1]).title
                                    .main
                                : "Select artwork to compare"
                            )
                          }
                        })
                      }),
                      0
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("h4", [_vm._v("Refine results")]),
              _vm._v(" "),
              _c("div", { staticClass: "meta-box" }, [
                _c("h4", { staticClass: "meta-title" }, [_vm._v("Materials")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "toggle" },
                  _vm._l(_vm.list.materials, function(material, key) {
                    return _c("div", { staticClass: "ui-checkbox" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.materials,
                              expression: "model.materials"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: material,
                            checked: Array.isArray(_vm.model.materials)
                              ? _vm._i(_vm.model.materials, material) > -1
                              : _vm.model.materials
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = _vm.model.materials,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = material,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.model,
                                        "materials",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.model,
                                        "materials",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.model, "materials", $$c)
                                }
                              },
                              function($event) {
                                return _vm.reset()
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "checkbox" }),
                        _vm._v(" "),
                        _c("span", {
                          domProps: { textContent: _vm._s(material) }
                        })
                      ])
                    ])
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-block" }, [
                _c(
                  "label",
                  { staticClass: "form-label", attrs: { id: "sort-by" } },
                  [
                    _c("span", { staticClass: "label" }, [_vm._v("Sort by")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-field select" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.sortby,
                              expression: "model.sortby"
                            }
                          ],
                          staticClass: "field",
                          attrs: { disabled: _vm.isLoading },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.model,
                                  "sortby",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              function($event) {
                                return _vm.sortBy()
                              }
                            ]
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Default")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "A-Z" } }, [
                            _vm._v("A-Z")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "Z-A" } }, [
                            _vm._v("Z-A")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "YearAsc" } }, [
                            _vm._v("Year ↑")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "YearDesc" } }, [
                            _vm._v("Year ↓")
                          ])
                        ]
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "meta-box seperator" }, [
                _c("div", { staticClass: "ui-checkbox" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.favourites,
                          expression: "model.favourites"
                        }
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.model.favourites)
                          ? _vm._i(_vm.model.favourites, null) > -1
                          : _vm.model.favourites
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.model.favourites,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.model,
                                    "favourites",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.model,
                                    "favourites",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.model, "favourites", $$c)
                            }
                          },
                          function($event) {
                            return _vm.reset()
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "checkbox" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("My favourites")])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "meta-box seperator" }, [
                _c("div", { staticClass: "ui-checkbox" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.attributed_to,
                          expression: "model.attributed_to"
                        }
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.model.attributed_to)
                          ? _vm._i(_vm.model.attributed_to, null) > -1
                          : _vm.model.attributed_to
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.model.attributed_to,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.model,
                                    "attributed_to",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.model,
                                    "attributed_to",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.model, "attributed_to", $$c)
                            }
                          },
                          function($event) {
                            return _vm.reset()
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "checkbox" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Attributed to")])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "meta-box seperator" }, [
                _c("div", { staticClass: "ui-radio" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.item_in,
                          expression: "model.item_in"
                        }
                      ],
                      attrs: { type: "radio", value: "Museum" },
                      domProps: {
                        checked: _vm._q(_vm.model.item_in, "Museum")
                      },
                      on: {
                        change: [
                          function($event) {
                            return _vm.$set(_vm.model, "item_in", "Museum")
                          },
                          function($event) {
                            return _vm.reset()
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "radio" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Museum")])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ui-radio" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.item_in,
                          expression: "model.item_in"
                        }
                      ],
                      attrs: { type: "radio", value: "Auction" },
                      domProps: {
                        checked: _vm._q(_vm.model.item_in, "Auction")
                      },
                      on: {
                        change: [
                          function($event) {
                            return _vm.$set(_vm.model, "item_in", "Auction")
                          },
                          function($event) {
                            return _vm.reset()
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "radio" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Auction")])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ui-radio" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.item_in,
                          expression: "model.item_in"
                        }
                      ],
                      attrs: { type: "radio", value: "Public Monument" },
                      domProps: {
                        checked: _vm._q(_vm.model.item_in, "Public Monument")
                      },
                      on: {
                        change: [
                          function($event) {
                            return _vm.$set(
                              _vm.model,
                              "item_in",
                              "Public Monument"
                            )
                          },
                          function($event) {
                            return _vm.reset()
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "radio" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Public Monument")])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ui-radio" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.item_in,
                          expression: "model.item_in"
                        }
                      ],
                      attrs: { type: "radio", value: "Private Collections" },
                      domProps: {
                        checked: _vm._q(
                          _vm.model.item_in,
                          "Private Collections"
                        )
                      },
                      on: {
                        change: [
                          function($event) {
                            return _vm.$set(
                              _vm.model,
                              "item_in",
                              "Private Collections"
                            )
                          },
                          function($event) {
                            return _vm.reset()
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "radio" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Private Collections")])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "meta-box is-accordion" }, [
                _c("h4", { staticClass: "meta-title" }, [_vm._v("Locations")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "toggle" },
                  _vm._l(_vm.list.locations, function(location, index) {
                    return _c("div", { staticClass: "ui-checkbox" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.tags["locations"],
                              expression: "model.tags['locations']"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: location,
                            checked: Array.isArray(_vm.model.tags["locations"])
                              ? _vm._i(_vm.model.tags["locations"], location) >
                                -1
                              : _vm.model.tags["locations"]
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = _vm.model.tags["locations"],
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = location,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.model.tags,
                                        "locations",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.model.tags,
                                        "locations",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.model.tags, "locations", $$c)
                                }
                              },
                              function($event) {
                                return _vm.reset()
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "checkbox" }),
                        _vm._v(" "),
                        _c("span", {
                          domProps: { textContent: _vm._s(location) }
                        })
                      ])
                    ])
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "meta-box is-accordion",
                  attrs: { id: "date-range" }
                },
                [
                  _c("h4", { staticClass: "meta-title" }, [_vm._v("Year")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "toggle" }, [
                    _c("div", { staticClass: "ui-checkbox" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.apply_year,
                              expression: "model.apply_year"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.model.apply_year)
                              ? _vm._i(_vm.model.apply_year, null) > -1
                              : _vm.model.apply_year
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = _vm.model.apply_year,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.model,
                                        "apply_year",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.model,
                                        "apply_year",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.model, "apply_year", $$c)
                                }
                              },
                              function($event) {
                                return _vm.reset()
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "checkbox" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Search by year")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { attrs: { id: "slider-range" } }),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-range" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.model.date.from,
                            expression: "model.date.from"
                          }
                        ],
                        staticClass: "date-from",
                        attrs: { type: "number" },
                        domProps: { value: _vm.model.date.from },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.model.date,
                              "from",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("to")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.model.date.to,
                            expression: "model.date.to"
                          }
                        ],
                        staticClass: "date-to",
                        attrs: { type: "number" },
                        domProps: { value: _vm.model.date.to },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.model.date, "to", $event.target.value)
                          }
                        }
                      })
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "meta-box is-accordion" }, [
                _c("h4", { staticClass: "meta-title" }, [_vm._v("Medium")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "toggle" },
                  _vm._l(_vm.list.medium, function(med, key) {
                    return _c(
                      "div",
                      {
                        staticClass: "meta",
                        class: { active: med === _vm.model.medium },
                        on: {
                          click: function($event) {
                            return _vm.selectMeta("medium", med)
                          }
                        }
                      },
                      [
                        _c("span", {
                          staticClass: "name",
                          domProps: { textContent: _vm._s(med) }
                        })
                      ]
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "meta-box is-accordion" }, [
                _c("h4", { staticClass: "meta-title" }, [_vm._v("Dimensions")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "toggle" },
                  _vm._l(_vm.list.dimensions, function(dimension, key) {
                    return _c(
                      "div",
                      {
                        staticClass: "meta",
                        class: { active: key === _vm.model.dimension },
                        on: {
                          click: function($event) {
                            return _vm.selectMeta("dimension", key)
                          }
                        }
                      },
                      [
                        _c("span", {
                          staticClass: "name",
                          domProps: { textContent: _vm._s(dimension) }
                        })
                      ]
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "meta-box is-accordion" }, [
                _c("h4", { staticClass: "meta-title" }, [
                  _vm._v("Foundry Marks")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "toggle" },
                  _vm._l(_vm.list.foundry_marks, function(foundry_mark, key) {
                    return _c(
                      "div",
                      {
                        staticClass: "meta",
                        class: {
                          active: foundry_mark === _vm.model.foundry_mark
                        },
                        on: {
                          click: function($event) {
                            return _vm.selectMeta("foundry_mark", foundry_mark)
                          }
                        }
                      },
                      [
                        _c("span", {
                          staticClass: "name",
                          domProps: { textContent: _vm._s(foundry_mark) }
                        })
                      ]
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "meta-box is-accordion" }, [
                _c("h4", { staticClass: "meta-title" }, [_vm._v("Busts")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "toggle" },
                  _vm._l(_vm.list.busts, function(bust, label) {
                    return _c("div", { staticClass: "ui-checkbox" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.tags["busts"],
                              expression: "model.tags['busts']"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: label,
                            checked: Array.isArray(_vm.model.tags["busts"])
                              ? _vm._i(_vm.model.tags["busts"], label) > -1
                              : _vm.model.tags["busts"]
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = _vm.model.tags["busts"],
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = label,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.model.tags,
                                        "busts",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.model.tags,
                                        "busts",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.model.tags, "busts", $$c)
                                }
                              },
                              function($event) {
                                return _vm.reset()
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "checkbox" }),
                        _vm._v(" "),
                        _c("span", { domProps: { textContent: _vm._s(label) } })
                      ])
                    ])
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "meta-box is-accordion" }, [
                _c("h4", { staticClass: "meta-title" }, [_vm._v("Animals")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "toggle" },
                  _vm._l(_vm.list.animals, function(animal, index) {
                    return _c("div", { staticClass: "ui-checkbox" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.tags["animals"],
                              expression: "model.tags['animals']"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: animal,
                            checked: Array.isArray(_vm.model.tags["animals"])
                              ? _vm._i(_vm.model.tags["animals"], animal) > -1
                              : _vm.model.tags["animals"]
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = _vm.model.tags["animals"],
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = animal,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.model.tags,
                                        "animals",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.model.tags,
                                        "animals",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.model.tags, "animals", $$c)
                                }
                              },
                              function($event) {
                                return _vm.reset()
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "checkbox" }),
                        _vm._v(" "),
                        _c("span", {
                          domProps: { textContent: _vm._s(animal) }
                        })
                      ])
                    ])
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "meta-box is-accordion" }, [
                _c("h4", { staticClass: "meta-title" }, [
                  _vm._v("Full-length Portraits")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "toggle" }, [
                  _c(
                    "div",
                    { staticClass: "option" },
                    [
                      _c("span", { staticClass: "name" }, [_vm._v("Men")]),
                      _vm._v(" "),
                      _vm._l(_vm.list.fullLengthPortraits_Men, function(
                        portrait,
                        label
                      ) {
                        return _c("div", { staticClass: "ui-checkbox" }, [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.model.tags["fullLengthPortraits_Men"],
                                  expression:
                                    "model.tags['fullLengthPortraits_Men']"
                                }
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                value: label,
                                checked: Array.isArray(
                                  _vm.model.tags["fullLengthPortraits_Men"]
                                )
                                  ? _vm._i(
                                      _vm.model.tags["fullLengthPortraits_Men"],
                                      label
                                    ) > -1
                                  : _vm.model.tags["fullLengthPortraits_Men"]
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a =
                                        _vm.model.tags[
                                          "fullLengthPortraits_Men"
                                        ],
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = label,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.model.tags,
                                            "fullLengthPortraits_Men",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.model.tags,
                                            "fullLengthPortraits_Men",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.model.tags,
                                        "fullLengthPortraits_Men",
                                        $$c
                                      )
                                    }
                                  },
                                  function($event) {
                                    return _vm.reset()
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "checkbox" }),
                            _vm._v(" "),
                            _c("span", {
                              domProps: { textContent: _vm._s(label) }
                            })
                          ])
                        ])
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "option" },
                    [
                      _c("span", { staticClass: "name" }, [_vm._v("Women")]),
                      _vm._v(" "),
                      _vm._l(_vm.list.fullLengthPortraits_Women, function(
                        portrait,
                        label
                      ) {
                        return _c("div", { staticClass: "ui-checkbox" }, [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.model.tags["fullLengthPortraits_Women"],
                                  expression:
                                    "model.tags['fullLengthPortraits_Women']"
                                }
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                value: label,
                                checked: Array.isArray(
                                  _vm.model.tags["fullLengthPortraits_Women"]
                                )
                                  ? _vm._i(
                                      _vm.model.tags[
                                        "fullLengthPortraits_Women"
                                      ],
                                      label
                                    ) > -1
                                  : _vm.model.tags["fullLengthPortraits_Women"]
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a =
                                        _vm.model.tags[
                                          "fullLengthPortraits_Women"
                                        ],
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = label,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.model.tags,
                                            "fullLengthPortraits_Women",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.model.tags,
                                            "fullLengthPortraits_Women",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.model.tags,
                                        "fullLengthPortraits_Women",
                                        $$c
                                      )
                                    }
                                  },
                                  function($event) {
                                    return _vm.reset()
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "checkbox" }),
                            _vm._v(" "),
                            _c("span", {
                              domProps: { textContent: _vm._s(label) }
                            })
                          ])
                        ])
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "option" },
                    [
                      _c("span", { staticClass: "name" }, [_vm._v("Children")]),
                      _vm._v(" "),
                      _vm._l(_vm.list.fullLengthPortraits_Children, function(
                        portrait,
                        label
                      ) {
                        return _c("div", { staticClass: "ui-checkbox" }, [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.model.tags[
                                      "fullLengthPortraits_Children"
                                    ],
                                  expression:
                                    "model.tags['fullLengthPortraits_Children']"
                                }
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                value: label,
                                checked: Array.isArray(
                                  _vm.model.tags["fullLengthPortraits_Children"]
                                )
                                  ? _vm._i(
                                      _vm.model.tags[
                                        "fullLengthPortraits_Children"
                                      ],
                                      label
                                    ) > -1
                                  : _vm.model.tags[
                                      "fullLengthPortraits_Children"
                                    ]
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a =
                                        _vm.model.tags[
                                          "fullLengthPortraits_Children"
                                        ],
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = label,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.model.tags,
                                            "fullLengthPortraits_Children",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.model.tags,
                                            "fullLengthPortraits_Children",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.model.tags,
                                        "fullLengthPortraits_Children",
                                        $$c
                                      )
                                    }
                                  },
                                  function($event) {
                                    return _vm.reset()
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "checkbox" }),
                            _vm._v(" "),
                            _c("span", {
                              domProps: { textContent: _vm._s(label) }
                            })
                          ])
                        ])
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "option" },
                    [
                      _c("span", { staticClass: "name" }, [_vm._v("Groups")]),
                      _vm._v(" "),
                      _vm._l(_vm.list.fullLengthPortraits_Groups, function(
                        portrait,
                        label
                      ) {
                        return _c("div", { staticClass: "ui-checkbox" }, [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.model.tags[
                                      "fullLengthPortraits_Groups"
                                    ],
                                  expression:
                                    "model.tags['fullLengthPortraits_Groups']"
                                }
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                value: label,
                                checked: Array.isArray(
                                  _vm.model.tags["fullLengthPortraits_Groups"]
                                )
                                  ? _vm._i(
                                      _vm.model.tags[
                                        "fullLengthPortraits_Groups"
                                      ],
                                      label
                                    ) > -1
                                  : _vm.model.tags["fullLengthPortraits_Groups"]
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a =
                                        _vm.model.tags[
                                          "fullLengthPortraits_Groups"
                                        ],
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = label,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.model.tags,
                                            "fullLengthPortraits_Groups",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.model.tags,
                                            "fullLengthPortraits_Groups",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.model.tags,
                                        "fullLengthPortraits_Groups",
                                        $$c
                                      )
                                    }
                                  },
                                  function($event) {
                                    return _vm.reset()
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "checkbox" }),
                            _vm._v(" "),
                            _c("span", {
                              domProps: { textContent: _vm._s(label) }
                            })
                          ])
                        ])
                      })
                    ],
                    2
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col l9 m12 s12" }, [
            _c(
              "div",
              {
                staticClass: "col-row col-auto-clear",
                attrs: { id: "list-artworks" }
              },
              _vm._l(_vm.posts, function(post, index) {
                return _vm.hasPosts
                  ? _c(
                      "div",
                      { key: "post-" + index, staticClass: "col l3 m3 s6" },
                      [
                        _c("div", { staticClass: "artwork" }, [
                          _c("figure", { staticClass: "img respond" }, [
                            _c("a", { attrs: { href: post.guid } }, [
                              _c("img", {
                                attrs: { src: post.image, alt: post.title.main }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c("h5", { staticClass: "title" }, [
                            _c("a", {
                              attrs: { href: post.guid },
                              domProps: {
                                innerHTML: _vm._s(
                                  post.title.main +
                                    (post.title.secondary
                                      ? " (" + post.title.secondary + ")"
                                      : "")
                                )
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "meta" }, [
                            post.year
                              ? _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(post.year + " &vert; ")
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", {
                              domProps: { textContent: _vm._s(post.medium) }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "actions" },
                            [
                              _vm.user_id
                                ? _c("favourite-artwork", {
                                    attrs: {
                                      post_id: post.id,
                                      favourited: post.favourited
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              post.image
                                ? _c("button", {
                                    staticClass: "compare fas fa-retweet",
                                    attrs: {
                                      type: "button",
                                      disabled: post.compared
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.addToCompare(post.id)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              }),
              0
            ),
            _vm._v(" "),
            !_vm.hasPosts && !_vm.isLoading
              ? _c("div", { staticClass: "noArtworks" }, [
                  _vm._v("\n\t\t\t\t\tNo artworks found\n\t\t\t\t")
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.showLoadMore
        ? _c("div", { staticClass: "view-more ui-text-center" }, [
            _c(
              "button",
              {
                staticClass: "ui-btn ui-btn-outline",
                attrs: {
                  type: "button",
                  disabled: _vm.isFinished || _vm.isLoading
                },
                domProps: {
                  textContent: _vm._s(
                    _vm.isLoading ? "Loading..." : "Load more"
                  )
                },
                on: { click: _vm.loadMore }
              },
              [_vm._v("Load more")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("a", {
        staticClass: "fa fa-chevron-up",
        attrs: { href: "javascript:void(0);", id: "backToTop" }
      })
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal" }, [
      _c("div", { staticClass: "artwork artwork-1" }, [
        _c("div", { staticClass: "img" }),
        _vm._v(" "),
        _c("div", { staticClass: "title" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "artwork artwork-2" }, [
        _c("div", { staticClass: "img" }),
        _vm._v(" "),
        _c("div", { staticClass: "title" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loader-icon" }, [
      _c("span", { staticClass: "fas fa-circle-notch fa-spin" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }